import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { TextField, MenuItem, Typography, Button, Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useFormik } from "formik";
import * as yup from "yup";
import UserService from "../../services/user";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const validationSchema = yup.object({
  mentor_id: yup.string("Enter Mentor name").required("Mentor is required"),
  mobile_no: yup.string().required("Mobile no is required"),
  msg: yup.string().required("Message is required"),
});

export default function SendSmsModal({ open, onClose, onSubmit }) {
  const [rowMentor, setRowMentor] = useState([]);

  const formik = useFormik({
    initialValues: {
      mobile_no: "",
      mentor_id: "",
      msg: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  const getMentors = async () => {
    try {
      let { data } = await UserService.fetchMentor();
      setRowMentor(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getMentors();
  }, []);

  useEffect(() => {
    if (formik.values.mentor_id) {
      const mentorPhone = rowMentor.find(
        (m) => m.id === formik.values.mentor_id
      )?.mobile_no;
      formik.setFieldValue("mobile_no", mentorPhone);
    }
  }, [formik.values.mentor_id]);

  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-sm">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Send SMS
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <form onSubmit={formik.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    id="mentor_id"
                    name="mentor_id"
                    label="Select Mentor"
                    value={formik.values.mentor_id}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    margin="dense"
                    size="small"
                    error={
                      formik.touched.mentor_id &&
                      Boolean(formik.errors.mentor_id)
                    }
                    helperText={
                      formik.touched.mentor_id && formik.errors.mentor_id
                    }
                  >
                    <MenuItem value={""}>Select Mentor</MenuItem>
                    {rowMentor?.map((mentor) => (
                      <MenuItem value={mentor.id}>{mentor.full_name}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    id="mobile_no"
                    name="mobile_no"
                    label="Mobile Number"
                    value={formik.values.mobile_no}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    multiline
                    margin="dense"
                    size="small"
                    error={formik.touched.mobile_no && Boolean(formik.errors.mobile_no)}
                    helperText={formik.touched.mobile_no && formik.errors.mobile_no}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    id="msg"
                    name="msg"
                    label="Message"
                    value={formik.values.msg}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    multiline
                    margin="dense"
                    size="small"
                    rows={4}
                    error={
                      formik.touched.msg &&
                      Boolean(formik.errors.msg)
                    }
                    helperText={
                      formik.touched.msg && formik.errors.msg
                    }
                  />
                </Grid>
              </Grid>
              <div className="text-right">
                <Button
                  color="primary"
                  sx={{ mr: 1, mt: 1 }}
                  variant="contained"
                  type="submit"
                >
                  Send
                </Button>
                <Button onClick={onClose} sx={{ mt: 1 }} variant="outlined">
                  Cancel
                </Button>
              </div>
            </form>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
